import gql from 'graphql-tag';

export const getProfile = gql`
  query getProfile {
    student {
      academic {
        campus
        campusDesc
        career
        faculty
        periodDesc
        plan
        prog
        progDesc
        period {
          description
          id
        }
        isGraduated
        hasBachelor
        # zone
      }
      profile {
        birthDate
        dni
        firstName
        lastName
        peopleCode
        studentCode
      }
    }
    zoomAccount {
      active
    }
    pendingDocument {
      active
    }
  }
`;

export const getStudentType = gql`
  query getStudentType($period: String!) {
    student {
      studentType(period: $period)
    }
  }
`;

export const getEmailAndPhone = gql`
  query getEmailAndPhone {
    student {
      email {
        email
        principal
        type
        hasEditingPermissionEmail
      }
      phone {
        phoneNumber
        principal
        type
        hasEditingPermissionPhone
      }
    }
  }
`;

export const getProfilePhoto = gql`
  query getProfilePhoto {
    profile {
      photo2 {
        url
        expiration
      }
    }
  }
`;

export const getModalityOfStudy = gql`
  query getModalityOfStudy {
    procedures {
      modalityOfStudy {
        code
        desc
        campus
      }
    }
  }
`;

export const getProfileTurn = gql`
  query turno($period: String!) {
    student {
      profile {
        firstName
      }
      enrolmentAppointmentV2(period: $period) {
        periodDesc
        date
        textDate
        textHour
        endEnrolmentText
        startClassText
        url
        whatsapp
        studentType
        enrolmentEnabled
        enrolmentPayment {
          enrolmentText
          enrolmentAmount
          assuranceText
          assuranceAmount
          pendingFeeText
          pendingFeeAmount
        }
      }
    }
  }
`;

export const getProfileTurnByPeriod = gql`
  query turno($period: String!) {
    student {
      enrolmentAppointmentByPeriod(period: $period) {
        date
        textDate
        textHour
      }
    }
  }
`;

export const sendValidationCode = gql`
  mutation sendValidationCode($email: String!, $phone: String!) {
    sendValidationCode(params: { email: $email, phone: $phone }) {
      status
    }
  }
`;

export const validateCode = gql`
  mutation validateCode($validationCode: Float!, $field: String!) {
    validateCode(validationCode: $validationCode, field: $field) {
      status
    }
  }
`;

export const updateDataProfile = gql`
  mutation updateDataProfile(
    $newValue: String!
    $oldValue: String!
    $type: String!
    $validationCode: String!
  ) {
    updateDataProfile(
      params: {
        newValue: $newValue
        oldValue: $oldValue
        type: $type
        validationCode: $validationCode
      }
    ) {
      status
      message
    }
  }
`;

export const getPeriods = gql`
  query getPeriodsAvailable {
    academicInformationV2 {
      periods {
        period
        isCurrent
      }
    }
  }
`;

export const getProfileData = gql`
  query getProfileData {
    profileData {
      studentCode
      nationalId
      birthdate
      cellPhone
      emailAddr
      maritalStatus
      maritalStatusDescr
      address1
      country
      countryDescr
      state
      stateDescr
      county
      countyDescr
      city
      cityDescr
      utpFlag
      utpTipoMovilidad
      tipoMovilidadDescr
      utpNroPlaca
      contactName
      relationship
      relationshipDescr
      emergencyPhone
      utpTipoDiscap
      utpDetaDiscap
      utpTipoCondicion
      utpDetaCondicion
      utpNroConadis
      utpNroResolucion
      utpGenero
      sex
      utpEstTrans
      utpDeclaracion
      utpComunidad
      utpPuebloOrig
      utpNomPueblo
      utpResolucPueblo
      utpLenguaMat
      utpCodCostumbres
    }
  }
`;

export const getProfileMastersData = gql`
  query getProfileMastersData($type: String!) {
    profileMastersData(type: $type) {
      id
      name
    }
  }
`;

export const updateProfile = gql`
  mutation updateProfile($updateRequests: [UpdateRequestInput!]!) {
    updateDataProfile2(updateRequests: $updateRequests) {
      status
      message
    }
  }
`;

export const getProfileAcl = gql`
  query getacl($params: AccessControlInput!) {
    securityPortal {
      acl(params: $params) {
        permission
        type
        page
        isNew
      }
    }
  }
`;
